import { RemittanceInfo } from "../../../../src/data/api/12-international-wire/remittance_info";
import * as React from 'react';
export default {
  RemittanceInfo,
  React
};